import React from 'react';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { IconButton } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { Alert } from '@mui/material';
import { getStorageItem, saveStorageItem } from '../../utilities/storageUtilities';

const styles = theme => ({
    alert: {
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        top: theme.spacing(3),
        zIndex: 1500
    },
});

class AlertMessage extends React.Component {
    state = {
        open: false
    }

    render() {
        const { classes, children, severity, variant } = this.props;
        const { open } = this.state;

        return (
            <>
                {open &&
                    <Alert
                        severity={severity}
                        variant={variant}
                        elevation={6}
                        className={classes.alert}
                        action={
                            <IconButton 
                                onClick={this.onCloseClick}
                                size='small'
                            >
                                <CloseIcon/>
                            </IconButton>
                        }
                    >
                        {children}
                    </Alert>
                }
            </>
        );
    }

    componentDidMount() {
        const { storageKey, showByDate } = this.props;

        const closed = getStorageItem(storageKey);
        const open = !Boolean(closed) && showByDate > Date.now();

        this.setState({open: open});
    }

    onCloseClick = () => {
        const { storageKey } = this.props;

        saveStorageItem(storageKey, true);
        this.setState({open: false});
    }
}

export default withStyles(AlertMessage, styles);